export default __webpack_public_path__ + "static/media/enter.210be8f7.wav";